var _path, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIssuer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Issuer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.263,
    height: 34.094,
    viewBox: "0 0 39.263 34.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M274.848,143.65H274.1l-19.256,7.393.376,2.026h3.867v16.683h1.912V153.069h5.019v16.645h2.251V153.069h4.927v16.645h2.1V153.069h4.927v16.645h2.251V153.069h4.927v16.877h2.1V153.069h4.241l.376-2.026Zm-.376,2.1,13.6,5.223H260.867Z",
    transform: "translate(-254.84 -143.65)",
    fill: "#ec0000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 34.453,
    height: 2.095,
    transform: "translate(2.405 28.274)",
    fill: "#ec0000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 2.483,
    height: 2.095,
    transform: "translate(36.004 31.999)",
    fill: "#ec0000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 5.456,
    height: 2.095,
    transform: "translate(28.245 31.999)",
    fill: "#ec0000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 25.374,
    height: 2.095,
    transform: "translate(0.543 31.999)",
    fill: "#ec0000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssuer);
export default __webpack_public_path__ + "static/media/Issuer.add61f8a1d5f89dd7665f7323c8c5a8c.svg";
export { ForwardRef as ReactComponent };